import React from "react";
import { useProductImage } from "hooks";
import { Icon } from "components/Icon/Icon";

export const ProductImage = ({
  pimId,
  width,
  height,
  productName,
}: {
  pimId: string | null;
  width: number;
  height: number;
  productName: string;
}) => {
  const { productImage, fetching } = useProductImage(pimId ?? "");
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        width,
        height,
        minWidth: width,
        minHeight: height,
      }}
    >
      {productImage ? (
        <img
          src={productImage}
          width={width}
          height={height}
          className="w-100 h-100 object-fit-contain m-0"
          alt={productName}
        />
      ) : (
        <>
          {!pimId || fetching ? (
            <Icon className="icon-64 m-2" iconName="squares-light" />
          ) : null}
        </>
      )}
    </div>
  );
};
